export default {
  'variable.title': 'Gestionar Variables',
  'variable.form.initialValue': 'Valor Inicial',
  'variable.form.text': 'Texto',
  'variable.form.number': 'Numérico',
  'variable.form.datetime': 'Fecha y Hora',
  'variable.form.date': 'Fecha',
  'variable.form.time': 'Hora',
  'variable.form.array': 'Matriz',
  'variable.form.object': 'Objeto',
};
